// @flow

export const IDENT_COURSE = 'gobbldygook/dnd/course'
export const IDENT_AREA = 'gobbldygook/dnd/area'
export const IDENT_YEAR = 'gobbldygook/dnd/year'
export const IDENT_SEMESTER = 'gobbldygook/dnd/semester'
export const IDENT_SCHEDULE = 'gobbldygook/dnd/schedule'
